import { useOrderFormStore } from '@/modules/order/stores/order-form.store'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'
import { isJSON } from '@/modules/shared/utils/general-helper'

import { useProductDetailsHistoryQuery } from '../querys/product-details-history.query'
import { useProductStore } from '../stores/product.store'
import type { IProductDetailsHistory } from '../types/product-details-history.type'

export const useProductDetailsHistoryHook = () => {
  const { jsonOrderForm } = useOrderFormStore()
  const { productIdSelected, isOpenModalDetailsProduct } = useProductStore()

  const { data } = useProductDetailsHistoryQuery({
    productId: productIdSelected,
    clientId: jsonOrderForm?.fkCliente,
    isOpenDetails: isOpenModalDetailsProduct,
  })

  const callbackFnToRequest = (dataRequest: ResponseAPI) => {
    if (dataRequest) {
      if (!isJSON(dataRequest.body)) return

      return JSON.parse(dataRequest.body) as IProductDetailsHistory[]
    }
  }

  const dataHistory = callbackFnToRequest(data)

  return {
    dataHistory,
  }
}
